// OBT F3-C — Kampanya raporu verisi (filtreli + sayfalı).
// Yalnız backend'in DESTEKLEDİĞİ filtreler (topic/status/park/only_late) buradan
// geçer; tarih/bölge/BM sunucu-tarafı filtresi backend'de YOK (ekran belirtir).
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchCampaignPage } from '../reportApi';
import { normalizeObtError } from '../../obtErrors';

const PAGE_SIZE = 20;

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

export function useCampaignReport({ enabled = true } = {}) {
  const [filters, setFilters] = useState({ topic: '', status: '', parkId: '', onlyLate: false });
  const [offset, setOffset] = useState(0);
  const [state, setState] = useState({ loading: enabled, error: null, page: null, items: [] });
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!enabled) {
      setState({ loading: false, error: null, page: null, items: [] });
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchCampaignPage(
        {
          topic: filters.topic || undefined,
          status: filters.status || undefined,
          parkId: filters.parkId || undefined,
          onlyLate: filters.onlyLate || undefined,
          limit: PAGE_SIZE,
          offset,
        },
        { signal: controller.signal }
      );
      if (controller.signal.aborted) return;
      setState({
        loading: false,
        error: null,
        page: data?.page || null,
        items: Array.isArray(data?.items) ? data.items : [],
      });
    } catch (error) {
      if (isCanceled(error) || controller.signal.aborted) return;
      setState({ loading: false, error: normalizeObtError(error), page: null, items: [] });
    }
  }, [enabled, filters, offset]);

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, [load]);

  const applyFilters = useCallback((next) => {
    setOffset(0);
    setFilters((prev) => ({ ...prev, ...next }));
  }, []);

  return {
    ...state,
    pageSize: PAGE_SIZE,
    offset,
    filters,
    setOffset,
    applyFilters,
    reload: load,
  };
}
